<template>
<div>
    <b-card no-body border-variant="msstream" class="marginal">
      <b-card-header header-bg-variant="msstream" header-text-variant="white" class="text-center">New Client</b-card-header>
      <b-card-body>
        <b-row>
          <b-form-textarea
                      id="textarea"
                      v-model="clientJs"
                      placeholder=""
                      rows="0"
                      max-rows="40"
                      >
          </b-form-textarea>
        </b-row>
    <b-row class="justify-content-center" style="margin-top:15px;">
        <b-button variant="green" @click="onSubmit()" ><i class="fas fa-check"></i> Create client</b-button>
    </b-row>
      </b-card-body>
    </b-card>

    <b-modal ref="error" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>Error</h3>
      </div>
      <p>Can not create the new client. Please try again later.</p>
      <b-row class="justify-content-around">
          <b-btn class="col-md-3 col-5" variant="mswarning" block @click="hideModal('error')">Close</b-btn>
      </b-row>
    </b-modal>

    <b-modal ref="created" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>New client created</h3>
      </div>
      <b-row class="justify-content-around">
          <b-btn class="col-md-3 col-5" variant="mswarning" block @click="hideModal('created');returnToAdmin();">Close</b-btn>
      </b-row>
    </b-modal>


  </div>
</template>

<script>
import ClientService from '@/services/client.service';
var clientService = new ClientService();
export default {
  name: 'ClientForm',
  data: function() {
    return {
    clientJs: JSON.stringify({
      "clientname": "",
      "email": "",
      "clientNumber": 0,
      "contractNumber": "",
      "SIRET": "",
      "contactFirstName": "",
      "contactName": "",
      "entrepriseName": "",
      "phone": "",
      "enterpriseName": "",
      "defaultAudio": true,
      "defaultEncodingLevel": 5,
      "defaultFirstPass": true,
      "maxViewingTime": 10000,
      "maxStorage": 3000,
      "maxEncodings": 10,
      "MB_month": 0,
    }, null, 2)

    }
  },
  mounted: function() {

  },
  methods: {
    onSubmit: function() {
      let client = {};
      try {
        client = JSON.parse(this.clientJs);
      } catch(err) {
        this.showModal('error');
      }
        clientService.postClient(client, this.$auth.token()).then(() => {
            this.showModal('created');
        }).catch((err) => {
            this.showModal('error');
        })
    },
    onReset: function() {

    },
    returnToAdmin: function() {
      this.$router.push('/admin');
    },
    showModal(modal) {
      this.$refs[modal].show();
    },
    hideModal(modal) {
      this.$refs[modal].hide();
    },
   
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
